import {TriggerTimeCondition} from '@models/adminstration/machine/trigger/trigger-time-condition';

export class TriggerExpression {
  arithmeticOperator?: ArithmeticOperator | null;
  signalLabel?: string;
  signalUnit?: string;
  triggerColumnName?: string;
  triggerCorrelation?: TriggerCorrelation | null;
  triggerExpressionType: string;
  triggerLastValue?: string;
  triggerPrecedentValue?: string;
  triggerTableName?: string;
  triggerTimeCondition?: TriggerTimeCondition | null;

  constructor(
    arithmeticOperator?: ArithmeticOperator,
    signalLabel = '',
    signalUnit = '',
    triggerColumnName = '',
    triggerCorrelation?: TriggerCorrelation,
    triggerExpressionType = '',
    triggerLastValue = '',
    triggerPrecedentValue = '',
    triggerTableName = '',
    triggerTimeCondition = null,
  ) {
    this.arithmeticOperator = arithmeticOperator || null;
    this.signalLabel = signalLabel;
    this.signalUnit = signalUnit;
    this.triggerColumnName = triggerColumnName;
    this.triggerCorrelation = triggerCorrelation || null;
    this.triggerExpressionType = triggerExpressionType;
    this.triggerLastValue = triggerLastValue;
    this.triggerPrecedentValue = triggerPrecedentValue;
    this.triggerTableName = triggerTableName;
    this.triggerTimeCondition = triggerTimeCondition;
  }
}

export enum ArithmeticOperator {
  EQUAL = 'EQUAL',
  GREATER = 'GREATER',
}

export enum TriggerCorrelation {
  AND = 'AND',
  OR = 'OR',
  NONE = 'NONE',
}
